import script from "./VideoProjectExport.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoProjectExport.vue?vue&type=script&setup=true&lang=js"

import "./VideoProjectExport.vue?vue&type=style&index=0&id=66e2ff97&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e2ff97"]])

export default __exports__